var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgPatternRightlightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 822,
    viewBox: "0 0 708 822",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.25,
    y: 213.51,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.449,
    y: 201.706,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 201.706,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 201.706,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.648,
    y: 213.51,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.043,
    y: 213.51,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 213.51,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.059,
    y: 201.706,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.863,
    y: 213.51,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.664,
    y: 201.706,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.664,
    y: 178.1,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.664,
    y: 154.493,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.664,
    y: 130.884,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.059,
    y: 225.313,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.664,
    y: 225.313,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.449,
    y: 225.313,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 225.313,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 225.313,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.25,
    y: 189.903,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.449,
    y: 178.1,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 178.1,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 178.1,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.648,
    y: 189.903,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.043,
    y: 189.903,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 189.903,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.059,
    y: 178.1,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.863,
    y: 189.903,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.25,
    y: 166.297,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.449,
    y: 154.493,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 154.493,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 154.493,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.648,
    y: 166.297,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.043,
    y: 166.297,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 166.297,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.059,
    y: 154.493,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.863,
    y: 166.297,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.25,
    y: 142.687,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.25,
    y: 119.081,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.449,
    y: 130.884,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 130.884,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.648,
    y: 142.687,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.043,
    y: 142.687,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 142.687,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 130.884,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.863,
    y: 142.687,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.648,
    y: 119.081,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.043,
    y: 119.081,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 119.081,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.059,
    y: 130.884,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.863,
    y: 119.081,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 118.712,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 136.417,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 171.827,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 183.63,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 136.417,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 171.827,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 183.63,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 195.436,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.262,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 165.925,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 189.532,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 213.141,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 118.712,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 136.418,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.656,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 165.925,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 189.532,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 213.141,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.756,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 118.712,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 136.418,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.883,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 136.418,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.484,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 165.928,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 189.535,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 213.141,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.975,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 118.713,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 136.418,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.848,
    y: 230.847,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 165.929,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 189.535,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 213.142,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.947,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 118.713,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 118.713,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 165.926,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 189.532,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 213.142,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 136.418,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 230.847,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 165.926,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 189.532,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 213.142,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.168,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 118.712,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 136.417,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.457,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 165.928,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 189.535,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 213.141,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.557,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 118.712,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 136.417,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 165.925,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 189.532,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 213.141,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 118.712,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 136.417,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.277,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 165.925,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 189.532,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 213.141,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 118.713,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 118.713,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 165.929,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 189.535,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 213.142,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 124.614,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 136.418,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 148.221,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 160.024,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 171.83,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 183.633,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 195.437,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 207.24,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 219.043,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.285,
    y: 230.846,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 130.516,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 142.319,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 154.122,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 165.929,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 177.732,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 189.535,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 201.338,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 213.142,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.379,
    y: 224.945,
    width: 2.95172,
    height: 2.95172,
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.336,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.551,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.434,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.77,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.148,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.246,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.652,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.453,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.848,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.965,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.062,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 470.655,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 476.557,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 488.36,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 500.163,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 511.967,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 523.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 535.576,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 547.379,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 559.183,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 570.986,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.57,
    y: 582.789,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 482.458,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 494.262,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 506.065,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 517.868,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 529.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 541.478,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 553.281,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 565.084,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.668,
    y: 576.887,
    width: 2.95172,
    height: 2.95172,
    fill: "#B2B2B2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.932,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.125,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.523,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.916,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.324,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.717,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.109,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.732,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.539,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.34,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.34,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.34,
    y: 272.529,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.34,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.732,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.34,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.125,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.523,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.916,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.932,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.125,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.523,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.916,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.324,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.717,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.109,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.732,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.539,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.932,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.125,
    y: 272.529,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.523,
    y: 272.529,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.916,
    y: 272.529,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.324,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.717,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.109,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.732,
    y: 272.529,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.539,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.932,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.932,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.125,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.523,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.324,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.717,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.109,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.916,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.539,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.324,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.717,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.109,
    y: 237.116,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.732,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.539,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.162,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.555,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.77,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 331.545,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 319.742,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 272.526,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.77,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.375,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.162,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.555,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 343.349,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.162,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.555,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.77,
    y: 296.136,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 307.939,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.162,
    y: 272.526,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.555,
    y: 272.526,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 272.526,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.77,
    y: 272.526,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 284.332,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.162,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.555,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 260.723,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.361,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.77,
    y: 248.92,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 237.117,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 1.47394,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 54.5916,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 66.3947,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 90.0012,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.32422,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 54.5916,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 66.3947,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 90.0012,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5352,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 13.2772,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 25.0805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 36.8836,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 48.6898,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 60.4933,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 72.2964,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 84.0996,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 95.9029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.42383,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 1.4743,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 54.5888,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 66.395,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 78.1983,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 90.0016,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.9375,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 13.2776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 25.0807,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 36.884,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 48.6873,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 60.4935,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 72.2966,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 84.1,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 95.9031,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.0371,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 1.47412,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 54.5887,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 66.3948,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 90.0013,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.1484,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 54.5888,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 66.3948,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 90.0013,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.756,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 13.2773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 25.0805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 36.8838,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 48.687,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 60.4933,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 72.2964,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 84.0999,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 95.903,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.248,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 1.47412,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 54.5916,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 66.3948,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 90.0013,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1348,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 13.2774,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 25.0805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 36.8838,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 48.6899,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 60.4933,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 72.2964,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 84.0999,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 95.903,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.2344,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 1.47412,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 1.47412,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 13.2774,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 25.0805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 36.8838,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 48.6871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 60.4933,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 72.2964,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 84.0999,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 95.903,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.6426,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 54.5888,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 66.3948,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 90.0013,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.3496,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 13.2772,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 25.0805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 36.8838,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 48.687,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 60.4933,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 72.2966,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 84.0999,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 95.9031,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.4434,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 1.4743,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 54.5917,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 66.395,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 78.1983,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 90.0016,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7402,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 13.2776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 25.0807,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 36.884,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 48.6902,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 60.4935,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 72.2965,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 84.1,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 95.9031,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.8398,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 1.4743,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 54.5917,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 66.395,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 78.1983,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 90.0016,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.957,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 13.2776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 25.0807,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 36.884,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 48.6902,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 60.4935,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 72.2965,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 84.1,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 95.9031,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.0566,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 1.47412,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 54.5916,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 66.3948,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 78.1981,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 90.0013,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 13.2774,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 25.0805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 36.8838,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 48.6899,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 60.4933,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 72.2964,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 84.0999,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 95.903,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.664,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 1.4743,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 1.4743,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 13.2776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 25.0807,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 36.884,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 48.6873,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 60.4935,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 72.2965,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 84.1,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 95.9031,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.8574,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 7.37567,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 19.179,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 30.9822,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 42.7855,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 54.5888,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 66.395,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 78.1983,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 90.0015,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 101.805,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.564,
    y: 113.608,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 13.2774,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 25.0807,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 36.884,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 48.6873,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 60.4935,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 72.2968,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 84.1,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 95.9033,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.658,
    y: 107.706,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 703.304,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 756.422,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.50977,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 756.422,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7246,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 750.52,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 797.733,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.609375,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 756.419,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.1152,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 750.518,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 797.734,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2148,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 756.419,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.332,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 756.419,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.939,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 750.517,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 797.733,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.4316,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 756.422,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3203,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 750.52,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 797.733,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.4199,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 750.517,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 797.733,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.8242,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 756.419,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.5312,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 750.517,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 797.734,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.625,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 756.422,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9238,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 750.52,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 797.733,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.0234,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 756.422,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1387,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 750.521,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 797.734,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.2383,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 756.422,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 750.52,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 797.733,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.846,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 703.305,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 750.518,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 797.734,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.0391,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 709.206,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 721.009,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 732.813,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 744.616,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 756.419,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 768.225,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 780.029,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 791.832,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 803.635,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.746,
    y: 815.438,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 715.108,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 726.911,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 738.714,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 750.518,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 762.324,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 774.127,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 785.93,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 797.734,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.84,
    y: 809.537,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 289.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.621,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 289.675,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522.836,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 260.167,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 283.776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.719,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 242.461,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 301.48,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.238,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 271.969,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 283.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 319.185,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.336,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 242.461,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.453,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 242.461,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.059,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 283.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.551,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.43,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 260.167,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 283.776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.531,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 283.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516.938,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.645,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 260.167,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 283.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528.738,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.047,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 283.776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.145,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.262,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 283.776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.359,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.859,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 283.776,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 236.56,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 260.166,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 283.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.16,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 242.462,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 254.265,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 266.068,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 277.871,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 289.674,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 301.481,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 313.284,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 325.087,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 336.89,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.867,
    y: 348.694,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 248.363,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 260.167,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 271.97,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 283.773,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 295.579,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 307.382,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 319.186,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 330.989,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.961,
    y: 342.792,
    width: 2.95172,
    height: 2.95172,
    fill: "#4D4D4D"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.146,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.953,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.854,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.047,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 425.971,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 414.167,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.861,
    y: 414.167,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 396.463,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 384.66,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 396.463,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 384.66,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 390.562,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.861,
    y: 390.562,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 443.679,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 455.482,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 467.286,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.154,
    y: 431.876,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 443.679,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 455.482,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 467.286,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.961,
    y: 431.876,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 437.777,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 449.581,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.055,
    y: 461.384,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.861,
    y: 437.777,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.861,
    y: 449.581,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.861,
    y: 461.384,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.461,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.854,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 425.971,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.461,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.854,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.461,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.854,
    y: 378.757,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.754,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.561,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.654,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.461,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.461,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.461,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.854,
    y: 425.973,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.07,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.463,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.27,
    y: 425.971,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.27,
    y: 414.167,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.07,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.27,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.463,
    y: 402.365,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.463,
    y: 378.757,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.07,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.363,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.463,
    y: 425.973,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.17,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.264,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.07,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.07,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.07,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 372.857,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 361.054,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 366.955,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 378.758,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 402.368,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 425.974,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 355.152,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 425.971,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 425.971,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 425.971,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 420.069,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 408.266,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 414.168,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 402.364,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 396.462,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 384.659,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 390.56,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 378.757,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.969,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.578,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 443.678,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 455.481,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 467.284,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.773,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.383,
    y: 431.874,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.875,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.477,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 437.776,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 449.579,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.676,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.281,
    y: 461.382,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.068,
    y: 425.973,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.73,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.93,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.322,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.715,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.123,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.516,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.908,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.539,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.336,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.141,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.141,
    y: 647.408,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.141,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.141,
    y: 600.192,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.539,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.141,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.93,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.322,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.715,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.73,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.93,
    y: 647.408,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.322,
    y: 647.408,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.715,
    y: 647.408,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.123,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.516,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.908,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.539,
    y: 647.408,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.336,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.73,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.93,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.322,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.715,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.123,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.516,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.908,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.539,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.336,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.73,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.73,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.93,
    y: 600.192,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.322,
    y: 600.192,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.123,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.516,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.908,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.715,
    y: 600.192,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.336,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.123,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.516,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.908,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.539,
    y: 600.192,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.336,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.773,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.977,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.367,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.758,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.168,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.562,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.953,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.582,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.383,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.184,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.184,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.184,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.184,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.582,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.184,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.977,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.367,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.758,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.773,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.977,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.367,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.758,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.168,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.562,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.953,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.582,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.383,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.773,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.977,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.367,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.758,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.168,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.562,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.953,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.582,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.383,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.773,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.773,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.977,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.367,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.168,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.562,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.953,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.758,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.383,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.168,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.562,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.953,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.582,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.383,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#B2B2B2"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.809,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.004,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.402,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.797,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.203,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.594,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.988,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.609,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.418,
    y: 682.817,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.219,
    y: 671.014,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.219,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.219,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.219,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.609,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.219,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.004,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.402,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.797,
    y: 694.62,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.809,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.004,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.402,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.797,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.203,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.594,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.988,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.609,
    y: 647.407,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.418,
    y: 659.211,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.809,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.004,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.402,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.797,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.203,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.594,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.988,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.609,
    y: 623.798,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.418,
    y: 635.604,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.809,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 540.809,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 529.004,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 505.402,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.203,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.594,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.988,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.797,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.418,
    y: 611.995,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517.203,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 493.594,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.988,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552.609,
    y: 600.191,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564.418,
    y: 588.388,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 541.459,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 511.952,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 500.148,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 511.952,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 500.148,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 506.05,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 506.05,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 559.167,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 570.971,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 582.774,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.918,
    y: 547.364,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 559.167,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 570.971,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 582.774,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.727,
    y: 547.364,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 553.266,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 565.069,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.82,
    y: 576.872,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 553.266,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 565.069,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 576.872,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 541.463,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 535.561,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 523.758,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 535.561,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 523.758,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 529.659,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 529.659,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 517.856,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 517.856,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 494.248,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.523,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.332,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619.43,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 607.625,
    y: 541.464,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.836,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 541.459,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.836,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 494.248,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.836,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.133,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.23,
    y: 541.464,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.938,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.031,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.836,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.836,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.836,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 488.345,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 476.542,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 482.444,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 494.247,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 541.46,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.832,
    y: 470.64,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 541.459,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 541.459,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 541.459,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 535.557,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 523.754,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 529.656,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.832,
    y: 517.853,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 511.953,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 500.149,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 506.051,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.832,
    y: 494.248,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.738,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.34,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 559.168,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 570.972,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 582.775,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.539,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.148,
    y: 547.365,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.633,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690.242,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 553.267,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 565.07,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.438,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.047,
    y: 576.873,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654.832,
    y: 541.464,
    width: 5.90182,
    height: 5.90182,
    fill: "#4D4D4D"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 95.1017,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 83.2985,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 83.2985,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 83.2985,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 95.1017,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 95.1017,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 95.1017,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 83.2985,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 95.1017,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 83.2985,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 59.692,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 36.0824,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 12.476,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 106.905,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 106.905,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 106.905,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 106.905,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 106.905,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 71.4952,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 59.692,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 59.692,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 59.692,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 71.4952,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 71.4952,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 71.4952,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 59.6921,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 71.4952,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 47.8886,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 36.0824,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 36.0824,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 36.0824,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 47.8886,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 47.8886,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 47.8886,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 36.0824,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 47.8886,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 24.2793,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 0.672729,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 12.476,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 12.476,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 24.2793,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 24.2793,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 24.2793,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 12.476,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 24.2793,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 0.672729,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 0.672729,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 0.672729,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 12.476,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 0.672729,
    width: 5.90182,
    height: 5.90182,
    fill: "#808080"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 213.141,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 201.338,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 201.338,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 201.338,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 213.141,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 213.141,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 213.141,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 201.338,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 213.141,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 201.338,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 177.732,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 154.122,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 130.516,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 224.944,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.957,
    y: 224.944,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 224.944,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 224.944,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 224.944,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 189.535,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 177.732,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 177.732,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 177.732,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 189.535,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 189.535,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 189.535,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 177.732,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 189.535,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 165.928,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 154.122,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 154.122,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 154.122,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 165.928,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 165.928,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 165.928,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 154.122,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 165.928,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 142.319,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.543,
    y: 118.712,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.742,
    y: 130.516,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 625.141,
    y: 130.516,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 142.319,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 142.319,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 142.319,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.535,
    y: 130.516,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 142.319,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.941,
    y: 118.712,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.336,
    y: 118.712,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.727,
    y: 118.712,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.352,
    y: 130.516,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.156,
    y: 118.712,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_277_377)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.34,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.438,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.438,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.242,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.34,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.145,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.34,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 774.126,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.152,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 744.619,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 732.815,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 744.619,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 732.815,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 738.717,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.152,
    y: 738.717,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 791.834,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 803.638,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 815.441,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.445,
    y: 780.031,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 791.834,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 803.638,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 815.441,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.25,
    y: 780.031,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 785.933,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 797.736,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.348,
    y: 809.539,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.152,
    y: 785.933,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.152,
    y: 797.736,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.152,
    y: 809.539,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.145,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 774.126,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.145,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.145,
    y: 726.912,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.047,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.852,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.945,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.75,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.145,
    y: 774.128,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.754,
    y: 703.308,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.562,
    y: 774.126,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.562,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.363,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.562,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.754,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.754,
    y: 726.912,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.656,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.754,
    y: 774.128,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.461,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.555,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 721.012,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 709.209,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 715.111,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 726.914,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 750.523,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 774.13,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 703.307,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 774.126,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 774.126,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 774.126,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 768.225,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 756.421,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 762.323,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 750.52,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 744.617,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 732.814,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 738.716,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 726.912,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.262,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.867,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 791.833,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 803.636,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 815.439,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.066,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.672,
    y: 780.03,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.164,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.766,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 785.931,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 797.735,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.969,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.574,
    y: 809.538,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.359,
    y: 774.128,
    width: 5.90182,
    height: 5.90182,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(352.438 119.08)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(234.148 118.712)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(352.438 470.657)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(116.111 237.116)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(234.148 237.116)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(1.42969 1.47339)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(0.611328 703.306)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(469.727 236.56)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(234.148 355.151)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(233.914 588.388)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(351.945 588.388)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(469.988 588.388)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(589.914 470.64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(589.73 0.673767)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(589.73 118.712)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_277_377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.036,
    height: 118.036,
    fill: "white",
    transform: "translate(352.438 703.306)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternRightlightMode);
export default __webpack_public_path__ + "static/media/bg-pattern-right(light-mode).c029e7364152bd84f413c717c758a2e2.svg";
export { ForwardRef as ReactComponent };